// Per-product branding configuration for web app.
// Poll-type → brand mapping: form polls = DooQuest; others = DooDates

export interface Brand {
  productName: string;
  domain: string;
  supportEmail: string;
  privacyEmail: string;
  resendApiKeyEnv: string;
}

const BRANDS: Record<"doodates" | "dooquest", Brand> = {
  doodates: {
    productName: "DooDates",
    domain: "doodates.com",
    supportEmail: "support@doodates.com",
    privacyEmail: "privacy@doodates.com",
    resendApiKeyEnv: "RESEND_API_KEY",
  },
  dooquest: {
    productName: "DooQuest",
    domain: "dooquest.com",
    supportEmail: "support@dooquest.com",
    privacyEmail: "privacy@dooquest.com",
    resendApiKeyEnv: "RESEND_API_KEY_DOOQUEST",
  },
};

export function brandForProductType(
  type?: "date" | "form" | "quizz" | "availability",
): Brand {
  return type === "form" ? BRANDS.dooquest : BRANDS.doodates;
}

export const defaultBrand = BRANDS.doodates;
